module.exports = __webpack_public_path__ + "static/media/cogs.63b9348e.svg";